import { BulletPointsWithImageType } from "@/@types/types";
import React from "react";
import { ImageWithPointsUi } from "./ImageWithPoints";

interface FeaturesProps {
  features: BulletPointsWithImageType;
  imageAlt?: string;
}

export const Features: React.FC<FeaturesProps> = ({ features, imageAlt }) => {
  return (
    <section className="section background">
      <ImageWithPointsUi
        direction={features.position}
        points={features.points}
        imageSrc={features.image.file.url}
        imageAlt={imageAlt}
      />
    </section>
  );
};
